module.exports = __webpack_public_path__ + "img/arrow-up-left.1022bb6f.svg";